import {FC, ReactNode, useEffect, useMemo, useState} from 'react';
import styles from './ConfirmationTemplateModal.module.scss';
import { ModalWithHeader } from '../../../common/ModalWithHeader';
import { DocumentSystem } from '../../../../models/DocumentSystem';
import { AcknowledgementsProcess } from '../../../../models/AcknowledgementsProcess';
import { TheButton } from '../../../common/TheButton';
import { Label, TextField } from '@fluentui/react';


interface IConfirmationTemplateModalProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  title: string | undefined;
  setTitle: (title: string) => void;
  isAdd: boolean;
  reason: string;
  documents: DocumentSystem[] | [];
  onConfirmForm: () => void;
  processes: AcknowledgementsProcess[] | [];
  children?: ReactNode;
}
export const ConfirmationTemplateModal: FC<IConfirmationTemplateModalProps> = ({
  isVisible,
  documents,
  processes,
  title,
  setTitle,
  isAdd,
  onConfirmForm,
  setIsVisible,
  reason,
}) => {


    const initialTitle = useMemo(() => {
      return isAdd ? "" : title;
    }, [isAdd, title]);


    useEffect(() => {
      if(isAdd)
      {
        setTitle('');
      }
    }, [isAdd]);

  return (
    <>
      <ModalWithHeader
        header={isAdd ? "Create Acknowledgement Template" : "Update Acknowledgement Template"}
        isVisible={isVisible}
        dismiss={() => setIsVisible(false)}>
           <Label className={styles.label}>Title</Label>
                      <TextField
                        className={styles.textField}
                        resizable={false}
                        defaultValue={initialTitle}
                        onChange={(e, value) => {
                          setTitle(value || '');
                        }}></TextField>
        {reason ? (
          <>
            <Label>Background / Reason</Label>
            <div
              className={styles.container}
              dangerouslySetInnerHTML={{
                __html: reason
              }}>
            </div>
          </>
        ) : undefined}
        {documents && documents.length ? (
          <>
            <Label>Choosen documents</Label>
            <div className={styles.container}>
              <ul>
                {documents.map((item, index) => (
                  <li key={index}>{item.title}</li>
                ))}
              </ul>
            </div>
          </>
        ) : undefined}

        {processes && processes.length ? (
          <>
            <Label>Choosen processes</Label>
            <div className={styles.container}>
              <ul>
                {processes.map((item, index) => (
                  <li key={index}>{item.title}</li>
                ))}
              </ul>
            </div>
          </>
        ) : undefined}

        <div className={styles.buttons}>
          <TheButton primary onClick={() => setIsVisible(false)}>
            Cancel
          </TheButton>

          <TheButton disabled={title === undefined || title.length === 0} primary onClick={() => onConfirmForm()}>
            {isAdd ? "Create" : "Update"}
          </TheButton>
        </div>
      </ModalWithHeader>
    </>
  );
};  
